import { useSignin } from '@/api/auth'
import { useGetChannelOwnerships } from '@/api/channel'
import pagePath from '@/utils/pagePath'
import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router'

const GoogleRedirect = () => {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  const navigate = useNavigate()
  const { mutate: signin } = useSignin()
  const { refetch } = useGetChannelOwnerships(false)

  useEffect(() => {
    if (!token) return

    signin(
      { token },
      {
        onSuccess: async () => {
          const { data: channels } = await refetch()
          if (channels?.length && channels.length > 0) {
            navigate(pagePath.channelVideos(channels[0].email), {
              replace: true,
            })
            return
          }
          navigate(pagePath.verifyChannel, {
            replace: true,
          })
        },
        onError: () => {
          navigate(pagePath.login, {
            replace: true,
          })
        },
      },
    )
  }, [navigate, refetch, signin, token])

  useEffect(() => {
    if (token === null) {
      navigate('/auth/login', {
        replace: true,
      })
    }
  }, [navigate, token])

  return null
}

export default GoogleRedirect
